import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'
import { FormDateInput, FormPhoneInput, FormTextInput } from '@divvy-web/skylab.form'
import { Control, useFormContext } from '@divvy-web/skylab.react-hook-form'

import PersonJobTitleDropdown from '@sputnik/components/PersonJobTitleDropdown'
import SSNPassportInput from '@sputnik/components/SSNPassportInput'
import { AddPersonForm } from '@sputnik/schema/creditApplication/addPerson'

import styles from './styles.module.scss'

interface PersonInfoFormProps {
  isAuthorizedSigner?: boolean
  className?: string
  control: Control<AddPersonForm>
  disabled?: boolean
}

const PersonInfoForm = ({ isAuthorizedSigner, className = '', control, disabled }: PersonInfoFormProps) => {
  const [getClassName] = useNameFormatter('PersonInfoForm')
  const { setValue } = useFormContext()

  return (
    <div className={`${styles[getClassName(className)]} dd-privacy-allow`}>
      <div className={styles[getClassName('person-details')]}>
        <FormTextInput
          className='dd-privacy-mask'
          control={control}
          disabled={disabled}
          label={
            <span className='dd-privacy-allow'>
              <FormattedMessage
                defaultMessage='First name'
                id='sputnik.PersonInfoForm__pONqz8'
              />
            </span>
          }
          name='firstName'
        />
        <FormTextInput
          className='dd-privacy-mask'
          control={control}
          disabled={disabled}
          label={
            <span className='dd-privacy-allow'>
              <FormattedMessage
                defaultMessage='Last name'
                id='sputnik.PersonInfoForm__txUL0F'
              />
            </span>
          }
          name='lastName'
        />
        <FormTextInput
          className='dd-privacy-mask'
          control={control}
          disabled={disabled}
          label={
            <span className='dd-privacy-allow'>
              <FormattedMessage
                defaultMessage='Business email'
                id='sputnik.PersonInfoForm__De2rFS'
              />
            </span>
          }
          name='email'
        />
        <FormPhoneInput
          className='dd-privacy-mask'
          control={control}
          disabled={disabled}
          label={
            <span className='dd-privacy-allow'>
              <FormattedMessage
                defaultMessage='Mobile number'
                id='sputnik.PersonInfoForm__JBLdZm'
              />
            </span>
          }
          name='phoneNumber'
        />
        {isAuthorizedSigner && (
          <PersonJobTitleDropdown
            // @ts-expect-error: Type narrowing for control to satisfy PersonJobTitleDropdown
            control={control as Control<Pick<AddPersonForm, 'title'>>}
            disabled={disabled}
          />
        )}
        <FormDateInput
          shouldRenderCalendar
          addCharactersAtPositions={{
            2: '/',
            5: '/',
          }}
          className='dd-privacy-mask'
          clearInvalidInput={false}
          control={control}
          disabled={disabled}
          formatOptions={{
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          }}
          label={
            <span className='dd-privacy-allow'>
              <FormattedMessage
                defaultMessage='Date of birth'
                id='sputnik.PersonInfoForm__GFTdXw'
              />
            </span>
          }
          maxLength={10}
          name='dob'
          placeholderGuide='MM/DD/YYYY'
          onChange={(_, date) => {
            if (!date) {
              return
            }
            if (setValue) {
              setValue('dob', new Date(date), { shouldValidate: true, shouldDirty: true })
            }
          }}
        />
      </div>
      <SSNPassportInput
        className={className}
        control={control}
        disabled={disabled}
      />
    </div>
  )
}

export default PersonInfoForm
